import { DIVERGENCE_FIELD  } from "./omega-node";
import { LUMINARY_CODE   } from "./matrix-payload";
import { AETHER_TIDE  } from "./delta-flux";


function decode(arr:number[]):string{
  return arr.map(x => String.fromCharCode(x)).join('');
}

export type VectorAxis = {
  nebulaFlux: string;
  quantumSeed: string;
  hyperVector: string;
  ghomoraThaS: string;
  antManWaspK: string;
};

export function yohainous(): VectorAxis{
  return {
    nebulaFlux: decode(DIVERGENCE_FIELD),
    quantumSeed: decode(LUMINARY_CODE),
    hyperVector: decode(AETHER_TIDE),
    ghomoraThaS: decode([100, 119, 105, 110, 100, 105, 119, 109, 119, 61, 61]),
    antManWaspK: decode([100, 119, 106, 100, 119, 105, 45, 106, 100, 119, 105, 106, 100, 119, 105, 119, 105, 110, 119, 100, 105, 100, 119, 105, 110, 100, 105, 119, 109, 119, 99, 105, 110, 113, 112, 112, 107, 113, 61])
  };
}